"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var CheckboxLabel = _styledComponents.default.div.withConfig({
  displayName: "CheckboxGroupstyle__CheckboxLabel",
  componentId: "sc-14csed8-0"
})(["color:", ";", " font-size:", ";font-weight:", ";"], function (_ref) {
  var theme = _ref.theme,
    light = _ref.light;
  return light ? theme.formField.labelColorLight : theme.formField.labelColor;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: ", ";\n  "])), function (_ref2) {
  var theme = _ref2.theme,
    indent = _ref2.indent;
  return indent ? theme.space.xl : 0;
}), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize.xs;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeight.bold;
});
exports.CheckboxLabel = CheckboxLabel;